import { commentFeeds } from '@/mocks/blackliao';

export default function CommentBoard() {
  return (
    <section id="comments" className="w-full bg-background-100/60">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-5 md:mb-7">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-800 whitespace-nowrap">
              <i className="ri-community-line"></i>新黑料网社区评论
            </span>
            <h2 className="mt-2.5 text-xl md:text-2xl font-black text-foreground-950">围观网友现场，大家都在说些什么</h2>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-600">最新新黑料网评论实时滚动，紧跟每一波节奏的讨论风向。</p>
          </div>
          <button className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-foreground-900 px-4 h-9 text-sm font-semibold text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer">
            <i className="ri-refresh-line"></i>换一批评论
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 md:gap-4">
          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 flex items-center gap-1.5">
                <i className="ri-message-2-fill text-primary-500"></i>实时评论流
              </h3>
              <span className="flex items-center gap-1 text-[11px] text-primary-600 whitespace-nowrap">
                <i className="ri-radio-2-fill animate-pulse"></i>直播中
              </span>
            </div>
            <div className="space-y-3">
              {commentFeeds.map((c) => (
                <div key={c.id} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 md:p-3.5">
                  <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-primary-700 font-bold text-sm ${c.id % 2 === 0 ? 'bg-accent-100 text-accent-700' : 'bg-primary-100'}`}>
                    <i className="ri-user-smile-fill text-lg"></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-[13px] font-bold text-foreground-900 whitespace-nowrap">{c.nick}</span>
                      <span className="text-[10px] text-foreground-400 whitespace-nowrap">{c.time}</span>
                      <span className="ml-auto flex items-center gap-1 text-[11px] text-primary-600 whitespace-nowrap">
                        <i className="ri-thumb-up-line"></i>{c.likes}
                      </span>
                    </div>
                    <p className="mt-1 text-[13px] leading-relaxed text-foreground-800">{c.text}</p>
                    <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
                      <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 whitespace-nowrap"><i className="ri-reply-line"></i>回复 {c.replies}</span>
                      <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 whitespace-nowrap"><i className="ri-more-fill"></i>展开</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-4 flex gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700"><i className="ri-user-add-line"></i></span>
              <div className="flex-1 rounded-md border border-background-200 bg-background-100 px-3 flex items-center">
                <input placeholder="我也想说两句，理性围观……" className="w-full bg-transparent py-2.5 text-sm outline-none placeholder:text-foreground-400" />
              </div>
              <button className="whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">发布</button>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-foreground-950 p-4 md:p-6 text-background-50 flex flex-col">
            <div className="flex items-center gap-1.5 text-sm md:text-base font-bold">
              <i className="ri-eye-fill text-accent-400"></i>围观现场
            </div>
            <p className="mt-1.5 text-xs md:text-sm text-background-100/80">围观新黑料网热帖与讨论的实时窗口，热度、方向、参与者一目了然。</p>
            <div className="mt-4 flex items-center justify-between rounded-lg bg-background-50/10 px-3 py-3">
              <div className="text-center">
                <div className="text-xl font-black text-accent-300">5.2<span className="text-xs">万</span></div>
                <div className="text-[10px] text-background-100/70 mt-0.5">正在围观</div>
              </div>
              <div className="h-8 w-px bg-background-50/15"></div>
              <div className="text-center">
                <div className="text-xl font-black text-accent-300">438</div>
                <div className="text-[10px] text-background-100/70 mt-0.5">今日新增</div>
              </div>
              <div className="h-8 w-px bg-background-50/15"></div>
              <div className="text-center">
                <div className="text-xl font-black text-accent-300">97</div>
                <div className="text-[10px] text-background-100/70 mt-0.5">高能预警</div>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <a href="#hot" className="inline-flex items-center gap-1 rounded-md border border-background-50/20 px-3 py-1.5 text-[11px] hover:bg-background-50/10 transition-colors whitespace-nowrap"><i className="ri-fire-line text-accent-300"></i>追热帖</a>
              <a href="#forum" className="inline-flex items-center gap-1 rounded-md border border-background-50/20 px-3 py-1.5 text-[11px] hover:bg-background-50/10 transition-colors whitespace-nowrap"><i className="ri-chat-3-line text-accent-300"></i>进讨论</a>
              <span className="inline-flex items-center gap-1 rounded-md border border-primary-500/50 px-3 py-1.5 text-[11px] text-primary-200 whitespace-nowrap"><i className="ri-emotion-happy-line"></i>理性吃瓜</span>
            </div>
            <div className="mt-auto pt-4">
              <div className="rounded-lg bg-primary-500/90 p-3">
                <p className="text-xs leading-relaxed text-background-50">本社区倡导有理有据的讨论，欢迎友善补充爆料，拒绝人身攻击与造谣传谣。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}